import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { Navigate, useLocation, useParams } from 'react-router-dom'
import styled from 'styled-components'

import { useHeaderNav } from 'context/headerNavContext'
import { usePageTitle } from 'context/pageTitleContext'
import DesktopAdditionalContent from 'features/DesktopAdditionalContent/DesktopAdditionalContent'
import WithHeaderSection from 'layouts/WithHeaderSection/WithHeaderSection'
import colors from 'styles/colors'

import { useGetArticle } from '../service/react-query/useGetArticle/useGetArticle'

export const Article = () => {
    const { setTitle } = usePageTitle()
    const { setHeaderNav } = useHeaderNav()
    const { t } = useTranslation()
    const { id } = useParams<{ id: string }>()
    const { state, pathname } = useLocation()

    const { data: article } = useGetArticle(id)

    const renderHeader = () => {
        switch (true) {
            case id === 'tutorials':
                return <StyledSectionTitle>{t('tutorials')}</StyledSectionTitle>

            case id === 'faq':
                return <StyledSectionTitle>{t('faq')}</StyledSectionTitle>

            case pathname.split('/')[3] === id?.toString():
                return (
                    <>
                        <StyledSectionTitle>
                            {t(state?.sectionName)}
                        </StyledSectionTitle>
                        <StyledTitle>{t(state?.title)}</StyledTitle>
                    </>
                )

            default:
                return <Navigate to={'/404'} />
        }
    }

    useEffect(() => {
        setTitle(t('howTo'))
        setHeaderNav(['/how-to/tutorials', '/how-to/faq'])

        return () => {
            setHeaderNav([]) // clean up nav on unmount
        }
    }, [setTitle, setHeaderNav, t])

    return (
        <>
            <WithHeaderSection customClass='article' headerSection={renderHeader()}>
            <StyledArticleContainer>
                <div
                dangerouslySetInnerHTML={{
                    __html: article?.data?.message?.body ?? ''
                }}
                />
            </StyledArticleContainer>
            <PaddingContainer></PaddingContainer>
            </WithHeaderSection>
            <DesktopAdditionalContent />
        </>
    )
}

const StyledSectionTitle = styled.h2`
    color: ${colors.slateBlueGray};
    font-size: 1.4rem;
    line-height: 1.7rem;
    font-weight: 600;
    letter-spacing: 0.02em;
`

const StyledTitle = styled.h3`
    font-size: 2.2rem;
    line-height: 2.9rem;
    font-weight: 600;
    letter-spacing: 0.02em;
`

const StyledArticleContainer = styled.div`
  background: white;
  border-radius: 2.2rem;
  padding: 2.4rem;
  margin-bottom:8rem;

  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05); 
`

const PaddingContainer = styled.div`
  padding-bottom: 2.4rem;
  margin-bottom:1rem;

`